// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2wx7L","header":"PatientBlock_header__kf1Wd","label":"PatientBlock_label__2GyT4","option":"PatientBlock_option__20Cvi"};